export const appTranslations = {
  en: () => import('./en.json').then(translations => ({ en: translations.default })),
  de: () => import('./de.json').then(translations => ({ de: translations.default })),
  fr: () => import('./fr.json').then(translations => ({ fr: translations.default })),
  nl: () => import('./nl.json').then(translations => ({ nl: translations.default })),
  sv: () => import('./sv.json').then(translations => ({ sv: translations.default })),
  fi: () => import('./fi.json').then(translations => ({ fi: translations.default })),
  es: () => import('./es.json').then(translations => ({ es: translations.default })),
  it: () => import('./it.json').then(translations => ({ it: translations.default })),
  pt: () => import('./pt.json').then(translations => ({ pt: translations.default })),
};

export const uiTranslations = {
  en: () =>
    import(/* webpackPrefetch: true */ '@core/user-interface-legacy/locales/en.json').then(
      translations => ({
        en: translations.default,
      }),
    ),
  de: () =>
    import('@core/user-interface-legacy/locales/de.json').then(translations => ({
      de: translations.default,
    })),
  fr: () =>
    import('@core/user-interface-legacy/locales/fr.json').then(translations => ({
      fr: translations.default,
    })),
  nl: () =>
    import('@core/user-interface-legacy/locales/nl.json').then(translations => ({
      nl: translations.default,
    })),
  sv: () =>
    import('@core/user-interface-legacy/locales/sv.json').then(translations => ({
      sv: translations.default,
    })),
  fi: () =>
    import('@core/user-interface-legacy/locales/fi.json').then(translations => ({
      fi: translations.default,
    })),
  es: () =>
    import('@core/user-interface-legacy/locales/es.json').then(translations => ({
      es: translations.default,
    })),
  it: () =>
    import('@core/user-interface-legacy/locales/it.json').then(translations => ({
      it: translations.default,
    })),
  pt: () =>
    import('@core/user-interface-legacy/locales/pt.json').then(translations => ({
      pt: translations.default,
    })),
};

export const wysiwygTranslations = {
  en: () =>
    import(
      /* webpackPrefetch: true */
      /* webpackChunkName: "ng-locale-en" */
      '@core/prosemirror-legacy/locales/src/en.json'
    ).then(t => ({ en: t.default })),
  de: () =>
    import(
      /* webpackChunkName: "ng-locale-de" */
      '@core/prosemirror-legacy/locales/src/de.json'
    ).then(t => ({ de: t.default })),
  fr: () =>
    import(
      /* webpackChunkName: "ng-locale-fr" */
      '@core/prosemirror-legacy/locales/src/fr.json'
    ).then(t => ({ fr: t.default })),
  nl: () =>
    import(
      /* webpackChunkName: "ng-locale-nl" */
      '@core/prosemirror-legacy/locales/src/nl.json'
    ).then(t => ({ nl: t.default })),
  sv: () =>
    import(
      /* webpackChunkName: "ng-locale-sv" */
      '@core/prosemirror-legacy/locales/src/sv.json'
    ).then(t => ({ sv: t.default })),
  fi: () =>
    import(
      /* webpackChunkName: "ng-locale-fi" */
      '@core/prosemirror-legacy/locales/src/fi.json'
    ).then(t => ({ fi: t.default })),
  es: () =>
    import(
      /* webpackChunkName: "ng-locale-es" */
      '@core/prosemirror-legacy/locales/src/es.json'
    ).then(t => ({ es: t.default })),
  it: () =>
    import(
      /* webpackChunkName: "ng-locale-it" */
      '@core/prosemirror-legacy/locales/src/it.json'
    ).then(t => ({ it: t.default })),
  pt: () =>
    import(
      /* webpackChunkName: "ng-locale-pt" */
      '@core/prosemirror-legacy/locales/src/pt.json'
    ).then(t => ({ pt: t.default })),
};
